import { render } from "./ModalUpdateTicket.vue?vue&type=template&id=0f45bb3f"
import script from "./ModalUpdateTicket.vue?vue&type=script&lang=js"
export * from "./ModalUpdateTicket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__